<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <form @submit.prevent="saveCategory">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Create category') }}</h1>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-6 shadow sm:rounded-lg">
                    <loading :status="loading"/>
                    <div class="bg-white md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
                        <div class="md:col-span-1">
                            <h3 class="text-lg font-medium leading-6 text-gray-900">{{ $t('Category details') }}</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                                {{ $t('Category name and parent category') }}.
                            </p>
                        </div>
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="name">{{ $t('Name') }}</label>
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <input
                                            id="name"
                                            v-model="category.name"
                                            :placeholder="$t('Name')"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                            required
                                        >
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="parent_id">{{ $t('Parent category') }}</label>
                                    <select
                                        id="parent_id"
                                        v-model="category.parent_id"
                                        class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 mt-1"
                                    >
                                        <option :value="null">{{ $t('None (root category)') }}</option>
                                        <option v-for="parent in parentCategories" :value="parent.id">{{ parent.name }}</option>
                                    </select>
                                    <div class="mt-2 relative text-xs text-gray-500">
                                        {{ $t('Maximum 2 levels of nesting. Only root categories can be selected as parent') }}.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-100 text-right px-4 py-3 sm:px-6">
                        <span class="inline-flex">
                            <router-link
                                class="btn btn-secondary shadow-sm rounded-md mr-4"
                                to="/dashboard/admin/product-categories"
                            >
                                {{ $t('Cancel') }}
                            </router-link>
                            <button
                                class="btn btn-green shadow-sm rounded-md"
                                type="submit"
                            >
                                {{ $t('Create category') }}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </form>
    </main>
</template>

<script>
export default {
    name: "new",
    metaInfo() {
        return {
            title: this.$i18n.t('Create category')
        }
    },
    data() {
        return {
            loading: true,
            parentCategories: [],
            category: {
                name: null,
                parent_id: null,
            },
        }
    },
    mounted() {
        this.getParentCategories();
    },
    methods: {
        saveCategory() {
            const self = this;
            self.loading = true;
            axios.post('api/dashboard/admin/product-categories', self.category).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/dashboard/admin/product-categories/' + response.data.category.id + '/edit');
            }).catch(function () {
                self.loading = false;
            });
        },
        getParentCategories() {
            const self = this;
            self.loading = true;
            axios.get('api/dashboard/admin/product-categories/select-list').then(function (response) {
                // Фильтруем: только корневые категории могут быть родительскими
                self.parentCategories = response.data.filter(c => c.parent_id === null);
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}
</script>
